import { useQuery } from '@tanstack/react-query';
import apiClient from '../api-client';

export type WinningSquarePeriod = {
  periodCode: string;
  rowTeamScore: number;
  colTeamScore: number;
  rowLastDigit: number;
  colLastDigit: number;
  winningRowIndex: number;
  winningColIndex: number;
  computedAtUtc: string | null;
};

type GetWinningSquaresResponse = {
  questionId: string;
  winningSquaresByPeriod: Record<string, number>; // periodCode -> squareNumber
  currentWinningSquareNumbers: number[]; // Most recent period's winners
  periods: WinningSquarePeriod[];
};

export const getWinningSquares = (contestId: string) =>
  apiClient.get<GetWinningSquaresResponse>(`/api/squares/${contestId}/winning-squares`);

export const useGetWinningSquaresQuery = (contestId: string | null) => {
  return useQuery<GetWinningSquaresResponse>({
    queryKey: ['squares', 'winning-squares', contestId],
    queryFn: () => getWinningSquares(contestId!),
    enabled: !!contestId,
    // Polls whenever enabled; callers keep contestId null until winners can exist.
    refetchInterval: 30_000,
  });
};
